import { Badge } from "@/components/ui/badge";

export default function RecordTag({ value, testId, className = "" }) {
  return (
    <Badge
      variant="outline"
      className={`border-[#d4af37]/25 bg-[#f8f2e8] font-mono text-[11px] tracking-[0.14em] text-[#7d673f] ${className}`.trim()}
      data-testid={testId}
    >
      {value}
    </Badge>
  );
}